<template>
	<Card :title="trans('enrollments.purchase-orders.title')" :subtitle="trans('enrollments.purchase-orders.description')">
		<List v-if="purchaseOrders.length > 0">
			<ListItem v-for="purchaseOrder in purchaseOrders" :title="`$ ${formatNumber(purchaseOrder.price)}`" :subtitle="dayjs(purchaseOrder.created_at).format(trans('general.dayjs.datetime'))">
				<template #accessory>
					<div class="flex items-center gap-3">
						<Badge :color="getPurchaseOrderColorByStatus(purchaseOrder.status)" active>{{ trans(`enrollments.purchase-orders.status.${purchaseOrder.status}`) }}</Badge>
						<Link :as="SecondaryButton" :color="Color.Blue" :href="route('events.enrollments.purchase-orders.show', [enrollment.id, purchaseOrder.id])" target="_blank">
							<i class="fa-solid fa-receipt mr-2"/>
							{{ trans('enrollments.purchase-orders.show') }}
						</Link>
					</div>
				</template>
			</ListItem>
		</List>
	</Card>
</template>
<script setup lang="ts">
import dayjs from 'dayjs'
import {route} from 'ziggy-js'
import {Link} from '@inertiajs/vue3'
import {trans} from 'laravel-vue-i18n'
import {formatNumber} from '@/helpers'
import {Color} from '@/Types/Enums/Color'
import Card from '@/Components/Cards/Card.vue'
import List from '@/Components/Lists/List.vue'
import {defineProps, type Ref, ref} from 'vue'
import Badge from '@/Components/Badges/Badge.vue'
import ListItem from '@/Components/Lists/ListItem.vue'
import {type Enrollment} from '@/Types/Events/Enrollments/Enrollment'
import SecondaryButton from '@/Components/Buttons/SecondaryButton.vue'
import {type PurchaseOrder} from '@/Types/Events/Enrollments/PurchaseOrders/PurchaseOrder'
import {getPurchaseOrderColorByStatus} from '@/Helpers/Events/Enrollments/PurchaseOrders/status'

const props = defineProps<{
	enrollment:Enrollment,
	purchaseOrders:Array<PurchaseOrder>,
}>()

const enrollment:Ref<Enrollment> = ref(props.enrollment)
const purchaseOrders:Ref<Array<PurchaseOrder>> = ref(props.purchaseOrders)
</script>